class APIS {
	apis() {
		return {
			fetchPostCategories: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/post_categories",
			},
			fetchCatPosts: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/posts",
			},
			fetchSearchedPosts: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/posts/search",
			},
			fetchGovNews: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/news",
			},
			fetchCompNews: {
				headers: {
					"xt-user-token": null,
				},
				method: "get",
				path: "/fetch/news/company_news/true",
			},
			fetchResources: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/resources",
			},
			
			
		};
	}
}

export default new APIS();
